"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllegroTransformProjectGenerator = void 0;
const TransformProject_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformProject");
const TransformProjectLayerSet_1 = require("../../../../Shared/HierarchicalTransformer/TransformObjects/TransformProjectLayerSet");
const allegroLayers_1 = require("../../../allegroLayers");
class AllegroTransformProjectGenerator {
    constructor() {
        this.runsFor = null;
    }
    *generate(_trigger, rootContext) {
        const designName = rootContext.parsedCpm.designName;
        const projectName = designName.length > 0 ? designName : 'Allegro Project';
        const project = new TransformProject_1.TransformProject({ name: projectName, type: 'allegro' }, rootContext);
        yield project;
        yield new TransformProjectLayerSet_1.TransformProjectLayerSet(project, {
            type: 'layerSet',
            id: allegroLayers_1.ALLEGRO_SCH_LAYERSET,
            layerSetType: 'schematic',
            layers: allegroLayers_1.AllegroSchLayers.map((layer) => ({ ...layer, defaultVisible: true })),
        });
    }
}
exports.AllegroTransformProjectGenerator = AllegroTransformProjectGenerator;
//# sourceMappingURL=AllegroTransformProjectGenerator.js.map